// src/context/GameContext.jsx
import { createContext } from 'react';

/**
 * GameContext is used to share game state globally.
 * Defined in a separate file for React Refresh compatibility.
 */
export const GameContext = createContext(null);
